<section class="detections" id="detections">
  <div class="detections__grid"></div>
  <div class="blob blob-1"></div>

  <div class="container">
    <div class="detections__header">
      <span class="section-tag">{{ t().det_tag }}</span>
      <h2 class="section-title">{{ t().det_title }}<br><span>{{ t().det_subtitle }}</span></h2>
    </div>

    <div class="detections__grid">
      <div class="det-card" *ngFor="let d of detections()">
        <div class="det-card__icon" [style.--det-color]="d.color">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
            <path d="M12 8v4l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <span class="det-card__label">{{ d.name }}</span>
      </div>
    </div>
  </div>
</section>